export enum PRODUCT_PAGE_VIEW{
    CONFIG_TOOL = "config-tool",
    COBRAND_ONBOARDING = "onboarding",
}

export enum PRODUCT_PAGE_TRIGGER{
    COB_ONBOARD = "COB_ONBOARD",
    CONFIG_TOOL = "CONFIG_TOOL",
    PERMISSIONS_PAGE = "PERMISSIONS_PAGE"
}

export enum STATUS_PAGE_TRIGGER{
    SITE_PAGE="SITE_PAGE",
    NOTIFICATION_PAGE="NOTIFICATION_PAGE"
}

export enum BrandType {
    SUB_BRAND = 1,
    CHANNEL = 2,
    COBRAND = 3,
    YODLEE = 4,
}